// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__TcPur","list":"styles_list__3KFzF"};